const locale = {
  placeholder: 'Select time',
}

export default locale



// WEBPACK FOOTER //
// ./components/time-picker/locale/en_GB.js